module.exports = __webpack_public_path__ + "static/img/relaxing-man.327234e2.svg";